import { useEffect, useMemo, useRef, useState } from "react";
import {
  TextField,
  Grid,
  MenuItem,
  Select,
  Typography,
  Box,
  Paper,
  InputLabel,
  FormControl,
  Chip,
  useTheme,
  Avatar,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Button,
  Divider,
  IconButton,
  Tooltip,
  Modal,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import Radio from "@mui/material/Radio";
import EditNoteIcon from "@mui/icons-material/EditNote";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import resistantIcon from "../../../images/resistance (1).png";
import interIcon from "../../../images/inter.png";
import sensitiveIcon from "../../../images/sensitive.png";
import { BASE_URL } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserDoctor, faUserNurse } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { LimitNotification } from "../../userDashboard/LimitNotifcation";
import { PlanExtensionDialog } from "../../userDashboard/PlanExtensionDialog";

import ReactQuill, { Quill } from "react-quill-new";
import QuillTableBetter from "quill-table-better";
import "react-quill-new/dist/quill.snow.css";
import "quill-table-better/dist/quill-table-better.css";

const toolbarOptions = [
  [{ header: "1" }, { header: "2" }, { font: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  ["bold", "italic", "underline", "strike"],
  [{ align: [] }],
  [{ color: [] }, { background: [] }],
  ["blockquote"],
  [{ script: "sub" }, { script: "super" }],
  [{ size: ["small", "medium", "large", "huge"] }],
];

Quill.register({ "modules/table-better": QuillTableBetter }, true);
const MicroBioInvestigation = ({
  investigation,
  index,
  compounds,
  invoice,
  sampleCollectedDate,
  sampleCollectedTime,
}) => {
  const [resultType, setResultType] = useState("");
  const [note, setNote] = useState("");
  const [openNotesInvestigation, setOpenNotesInvestigation] = useState(false);
  const [specimen, setSpecimen] = useState("");
  const [colonyCount, setColonyCount] = useState("");
  const [text, setText] = useState("");
  const [selectedOrganism, setSelectedOrganism] = useState("");
  const [sensitive, setSensitive] = useState([]);
  const [intermediate, setIntermediate] = useState([]);
  const [resistant, setResistant] = useState([]);
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [selectedTechnicians, setSelectedTechnicians] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [notif, setNotif] = useState({
    open: false,
    severity: "info",
    message: "",
  });
  const [dialogOpen, setDialogOpen] = useState(false);

  const quillRef = useRef(null);
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: 1 }, { header: 2 }], // custom button values
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["link", "image"],
          [{ list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction
          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],
          // ['tableUI']
          // ["table-better"], // Add table tool
        ],
      },
      table: false,
      "table-better": {
        language: "en_US",
        menus: [
          "column",
          "row",
          "merge",
          "table",
          "cell",
          "wrap",
          "copy",
          "delete",
        ],
        toolbarTable: true,
      },
      keyboard: {
        bindings: QuillTableBetter.keyboardBindings,
      },
    }),
    [],
  );

  const showNotification = (message, severity = "info") => {
    setNotif({ open: true, message, severity });
  };
  const handleClose = () => {
    setNotif((prev) => ({ ...prev, open: false }));
  };
  const handleExtendClick = () => {
    setDialogOpen(true);
  };

  const handleBuyPlan = (selectedPlan) => {
    // Call API or logic based on `selectedPlan` (e.g., "1_day", "1_week", "1_month")
    alert("User selected:", selectedPlan);
    // You could show a confirmation or trigger payment flow here
  };
  const getStyles = (name, selected) => ({
    fontWeight:
      selected.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  });

  const fetchAllDoctors = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-dept-signatory-doctors?cat=Microbiology`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      setDoctors(data.doctors);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to fetch doctors");
    } finally {
    }
  };
  const fetchAllTechnician = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-all-technicians`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      if (data.success) {
        setTechnicians(data.technicians);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to fetch Technicians");
    } finally {
    }
  };
  useEffect(() => {
    fetchAllDoctors();
    fetchAllTechnician();
    setText(investigation?.text);
    if (investigation?.investigation?.resultType) {
      setResultType(investigation?.investigation?.resultType);
      const doctors = investigation?.doctorSignatory?.map(
        (doc) => doc?.doctor?._id,
      );
      setSelectedDoctors(doctors);
      const techs = investigation?.techSignatory?.map(
        (tec) => tec?.technician?._id,
      );
      setSelectedTechnicians(techs);
      setSpecimen(investigation?.investigation?.specimen);
      setSelectedOrganism(investigation?.investigation?.organism);
      setSensitive(investigation?.investigation?.sensitive);
      setIntermediate(investigation?.investigation?.intermediate);
      setResistant(investigation?.investigation?.resistant);
      setColonyCount(investigation?.investigation?.colonyCount);
      setNote(investigation?.investigation?.note);
      setText(investigation?.investigation?.text);
    }
  }, []);

  const handleNoteChange = (value) => {
    setNote(value);
  };
  const submit = async () => {
    setLoading(true);
    if (selectedDoctors.length === 0) {
      toast.error("Please select atleast one doctor!");
      setLoading(false);
      return;
    }
    if (selectedTechnicians.length === 0) {
      toast.error("Please select atleast one technician!");
      setLoading(false);
      return;
    }
    let data;
    const doctorSignatory = selectedDoctors.map((doctorId) => ({
      doctor: doctorId,
      status: 1,
    }));
    const techSignatory = selectedTechnicians.map((techId) => ({
      technician: techId,
      status: 1,
    }));
    if (resultType === "positive") {
      data = {
        patientId: invoice?.patientId?._id,
        doctorId: invoice?.doctorId?._id,
        invoice: invoice?._id,
        result: {
          testId: investigation?.testId?._id,
          testName: investigation?.testId?.testName,
          investigation: {
            resultType,
            specimen,
            colonyCount,
            organism: selectedOrganism,
            sensitive,
            intermediate,
            resistant,
            text,
            note,
          },
          doctorSignatory: doctorSignatory,
          techSignatory: techSignatory,
          sampleCollectedDate,
          sampleCollectedTime,
        },
      };
    } else {
      data = {
        patientId: invoice?.patientId?._id,
        doctorId: invoice?.doctorId?._id,
        invoice: invoice?._id,
        result: {
          testId: investigation?.testId?._id,
          testName: investigation?.testId?.testName,
          investigation: {
            resultType,
            specimen,
            text,
            note,
          },
          doctorSignatory: doctorSignatory,
          techSignatory: techSignatory,
          sampleCollectedDate,
          sampleCollectedTime,
        },
      };
    }
    try {
      const response = await fetch(
        `${BASE_URL}api/user/microbiology/create-microbiology-report`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );
      const resp = await response.json();
      if (resp?.success) {
        toast.success(resp?.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else if (
        !resp?.success &&
        resp?.dailyLimitReached &&
        resp?.canExtendPlan
      ) {
        showNotification(resp.message, "warning");
      } else {
        toast.error("Failed to create report");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again later");
    } finally {
      setLoading(false);
    }
  };

  const update = async () => {
    setLoading(true);
    let data;
    if (selectedDoctors.length === 0) {
      toast.error("Please select atleast one doctor!");
      setLoading(false);
      return;
    }
    if (selectedTechnicians.length === 0) {
      toast.error("Please select atleast one technician!");
      setLoading(false);
      return;
    }
    const doctorSignatory = selectedDoctors.map((doctorId) => ({
      doctor: doctorId,
      status: 1,
    }));
    const techSignatory = selectedTechnicians.map((techId) => ({
      technician: techId,
      status: 1,
    }));
    if (resultType === "positive") {
      data = {
        invoice: invoice?._id,
        result: {
          testId: investigation?.testId?._id,
          testName: investigation?.testId?.testName,
          investigation: {
            resultType,
            specimen,
            colonyCount,
            organism: selectedOrganism,
            sensitive,
            intermediate,
            resistant,
            note,
          },
          doctorSignatory: doctorSignatory,
          techSignatory: techSignatory,
        },
      };
    } else {
      data = {
        invoice: invoice?._id,
        result: {
          testId: investigation?.testId?._id,
          testName: investigation?.testId?.testName,
          investigation: {
            resultType,
            specimen,
            text,
            note,
          },
          doctorSignatory: doctorSignatory,
          techSignatory: techSignatory,
        },
      };
    }
    // return;
    try {
      const response = await fetch(
        `${BASE_URL}api/user/microbiology/update-microbiology-report?reportId=${invoice._id}&testId=${data.result.testId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );
      const resp = await response.json();
      // alert(resp.message);
      toast.success(resp.message);
    } catch (err) {
      toast.error("Something went wrong. Please try again later");
    } finally {
      setLoading(false);
    }
  };

  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState(investigation.organism || []);
  const [showAddOption, setShowAddOption] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  const handleAdd = async () => {
    if (!inputValue.trim()) return;
    const testId = investigation?.testId?._id;
    try {
      setIsAdding(true);
      // 🔁 Replace with your actual API endpoint and payload
      const response = await axios.post(
        `${BASE_URL}api/user/microbiology/add-microbiology-organism`,
        {
          testId,
          organism: inputValue,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200 || response.status === 201) {
        const newOption = inputValue.trim();
        setOptions((prev) => [...prev, newOption]);
        setSelectedOrganism(newOption);
        setShowAddOption(false);
        toast.success(
          <span>
            Organism <strong>{newOption}</strong> added successfully.
          </span>,
        );
      }
    } catch (error) {
      toast.error("Error adding organism.");
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <>
      <LimitNotification
        open={notif.open}
        severity={notif.severity}
        message={notif.message}
        onClose={handleClose}
        onExtend={handleExtendClick}
      />
      <PlanExtensionDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onBuy={handleBuyPlan}
        cat="Microbiology"
      />
      <Modal
        open={openNotesInvestigation}
        onClose={() => setOpenNotesInvestigation(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            borderRadius: "8px",
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* <ReactQuill
            value={note}
            onChange={handleNoteChange}
            placeholder="Define the test structure..."
            modules={{
              toolbar: toolbarOptions,
            }}
            style={{ marginTop: 10 }}
          /> */}
          <ReactQuill
            ref={quillRef}
            modules={modules}
            value={note}
            onChange={handleNoteChange}
            placeholder="Define the test structure..."
          />
        </Box>
      </Modal>
      <Paper
        elevation={6}
        sx={{
          p: 3,
          pb: 3,
          my: 4,
          borderRadius: "10px",
          backdropFilter: "blur(12px)",
          background: "rgba(255, 255, 255, 0.75)",
          boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
          border: "1px solid rgba(255, 255, 255, 0.4)",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Chip
            avatar={
              <Avatar
                sx={{
                  backgroundColor: "#fb8500",
                  borderRadius: "50%",
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  // color: "white",
                }}
              >
                <span style={{ color: "white" }}>{index + 1}</span>
              </Avatar>
            }
            label={investigation?.testId?.testName}
          />
          <Tooltip title="Note" placement="left">
            <IconButton
              sx={{
                fontSize: "2.1rem",
              }}
              onClick={() => setOpenNotesInvestigation(true)}
            >
              <EditNoteIcon />
            </IconButton>
          </Tooltip>
        </Box>

        <Grid container spacing={2}>
          <Grid item md={3} xs={12}>
            {/* <Box
              sx={{
                display: "flex",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: "inset 0 0 8px rgba(0,0,0,0.05)",
              }}
            >
              <Box
                onClick={() => setResultType("positive")}
                sx={{
                  flex: 1,
                  py: 2,
                  cursor: "pointer",
                  textAlign: "center",
                  background: resultType === "positive" ? "#74c69d" : "#edf6f9",
                  color: resultType === "positive" ? "#1b4332" : "#40916c",
                  fontWeight: "bold",
                  transition: "all 0.3s",
                  "&:hover": { background: "#d8f3dc" },
                }}
              >
                <AddIcon />
                Positive
              </Box>
              <Box
                onClick={() => setResultType("negative")}
                sx={{
                  flex: 1,
                  py: 2,
                  cursor: "pointer",
                  textAlign: "center",
                  background: resultType === "negative" ? "#ff758f" : "#fff0f3",
                  color: resultType === "negative" ? "#800f2f" : "#c9184a",
                  fontWeight: "bold",
                  transition: "all 0.3s",
                  "&:hover": { background: "#ffd6e0" },
                }}
              >
                <RemoveIcon />
                Negative
              </Box>
            </Box> */}

            <Box
              sx={{
                display: "flex",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: "inset 0 0 8px rgba(0,0,0,0.05)",
              }}
            >
              <Box
                onClick={() => setResultType("positive")}
                sx={{
                  flex: 1,
                  py: 1,
                  cursor: "pointer",
                  textAlign: "center",
                  background: resultType === "positive" ? "#d8f3dc" : "#edf6f9",
                  color: resultType === "positive" ? "#1b4332" : "#40916c",
                  fontWeight: "bold",
                  transition: "all 0.3s",
                  "&:hover": { background: "#d8f3dc" },
                  display: "flex",
                  // flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Radio
                  checked={resultType === "positive"}
                  value="positive"
                  onChange={() => setResultType("positive")}
                  color="success"
                />
                Positive
              </Box>

              <Box
                onClick={() => setResultType("negative")}
                sx={{
                  flex: 1,
                  py: 1,
                  cursor: "pointer",
                  textAlign: "center",
                  background: resultType === "negative" ? "#ffd6e0" : "#fff0f3",
                  color: resultType === "negative" ? "#800f2f" : "#c9184a",
                  fontWeight: "bold",
                  transition: "all 0.3s",
                  "&:hover": { background: "#ffd6e0" },
                  display: "flex",
                  // flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Radio
                  checked={resultType === "negative"}
                  value="negative"
                  onChange={() => setResultType("negative")}
                  color="error"
                />
                Negative
              </Box>
            </Box>
          </Grid>

          <Grid item md={3} xs={12}>
            <TextField
              label="Specimen"
              variant="filled"
              value={specimen}
              onChange={(e) => setSpecimen(e.target.value)}
              fullWidth
            />
          </Grid>

          <Grid item md={3} xs={12}>
            {resultType === "positive" && (
              <Autocomplete
                fullWidth
                sx={{ mb: 3 }}
                options={options}
                value={selectedOrganism}
                onChange={(event, newValue) => {
                  setSelectedOrganism(newValue);
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                  const exists = options.includes(newInputValue);
                  setShowAddOption(!exists && newInputValue.trim() !== "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Organism"
                    variant="filled"
                  />
                )}
                noOptionsText={
                  showAddOption ? (
                    <Box>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        <strong>{inputValue}</strong>{" "}
                        <span style={{ color: "#ef233c" }}>not found!</span>
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <i style={{ fontSize: "10px" }}>
                          Do you want to add this Organism?
                        </i>
                        <Button
                          variant="text"
                          size="small"
                          color="success"
                          disabled={isAdding}
                          onMouseDown={(e) => {
                            e.preventDefault(); // Prevents blur
                            handleAdd();
                          }}
                          sx={{
                            backgroundColor: "#b7efc5",
                            "&:hover": {
                              backgroundColor: "#d6f5db",
                            },
                          }}
                        >
                          {isAdding ? <CircularProgress size={20} /> : "Add"}
                        </Button>
                      </div>
                    </Box>
                  ) : (
                    "No options"
                  )
                }
              />
            )}
          </Grid>
          <Grid item md={3} xs={12}>
            {resultType === "positive" && (
              <TextField
                label="Colony Count"
                variant="filled"
                value={colonyCount}
                onChange={(e) => setColonyCount(e.target.value)}
                fullWidth
              />
            )}
          </Grid>
        </Grid>

        {resultType === "negative" && (
          <Box mt={2}>
            {/* <ReactQuill theme="snow" value={text} onChange={setText} /> */}
            <ReactQuill
              ref={quillRef}
              modules={modules}
              value={text}
              onChange={setText}
              placeholder="Define the test structure..."
            />
            <Button
              sx={{ mt: 2 }}
              variant="contained"
              color="success"
              onClick={submit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </Button>
          </Box>
        )}

        {resultType === "positive" && (
          <>
            <Grid container spacing={2} mt={1}>
              {[
                {
                  label: "Sensitive",
                  color: "#d8f3dc",
                  state: sensitive,
                  setState: setSensitive,
                  icon: sensitiveIcon,
                  chipColor: "success",
                },
                {
                  label: "Intermediate",
                  color: "#fff4e6",
                  state: intermediate,
                  setState: setIntermediate,
                  icon: interIcon,
                  chipColor: "warning",
                },
                {
                  label: "Resistant",
                  color: "#ffe3e3",
                  state: resistant,
                  setState: setResistant,
                  icon: resistantIcon,
                  chipColor: "error",
                },
              ].map(({ label, state, setState, color, icon, chipColor }) => (
                <Grid item xs={12} md={4} key={label}>
                  <Chip
                    avatar={<Avatar src={icon} />}
                    label={label}
                    variant="outlined"
                    sx={{
                      mb: 1,
                      fontWeight: "bold",
                      bgcolor: "#ffffff",
                      color: theme.palette[chipColor].main,
                      borderColor: theme.palette[chipColor].main,
                    }}
                  />
                  <Select
                    multiple
                    fullWidth
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((val) => (
                          <Chip
                            key={val}
                            label={val}
                            sx={{
                              backgroundColor: color,
                              fontWeight: 500,
                              borderRadius: "10px",
                            }}
                          />
                        ))}
                      </Box>
                    )}
                    sx={{
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {compounds
                      .filter(
                        (compound) =>
                          !(
                            sensitive.includes(compound) ||
                            intermediate.includes(compound) ||
                            resistant.includes(compound)
                          ) || state.includes(compound),
                      )
                      .map((compound) => (
                        <MenuItem
                          key={compound}
                          value={compound}
                          style={getStyles(compound, state)}
                        >
                          <Checkbox
                            checked={state.indexOf(compound) > -1}
                            color={chipColor}
                          />
                          <ListItemText primary={compound} />
                        </MenuItem>
                      ))}
                  </Select>
                </Grid>
              ))}
            </Grid>
          </>
        )}
        <Divider
          sx={{
            borderColor: "#83c5be", // blue divider
            my: 3,
          }}
        />
        <Grid container spacing={2}>
          <Grid item md={5} xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={faUserDoctor}
                size="xl"
                style={{
                  marginRight: "10px",
                  background: "#cbf3f0",
                  padding: "11px 15px",
                  borderRadius: "5px",
                  color: "#2ec4b6",
                }}
              />

              <FormControl fullWidth>
                <InputLabel id="demo-multiple-checkbox-label" size="small">
                  Signatory Doctor
                </InputLabel>
                <Select
                  multiple
                  value={selectedDoctors}
                  size="small"
                  onChange={(e) => setSelectedDoctors(e.target.value)}
                  input={<OutlinedInput label="Signatory Doctor" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((val) => {
                        const doctor = doctors.find((d) => d._id === val);
                        return (
                          <Chip
                            key={val}
                            label={doctor?.name || val}
                            // color="primary"
                          />
                        );
                      })}
                    </Box>
                  )}
                >
                  {doctors?.map((doc) => (
                    <MenuItem key={doc._id} value={doc._id}>
                      <Checkbox checked={selectedDoctors?.includes(doc._id)} />
                      <ListItemText primary={doc.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <Grid item md={5} xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={faUserNurse}
                size="xl"
                style={{
                  marginRight: "10px",
                  background: "#d8f3dc",
                  padding: "11px 15px",
                  borderRadius: "5px",
                  color: "#52b788",
                }}
              />
              <FormControl fullWidth>
                <InputLabel id="technician-label" size="small">
                  Technician
                </InputLabel>
                <Select
                  labelId="technician-label"
                  multiple
                  value={selectedTechnicians} // Array of _id strings
                  onChange={(e) => setSelectedTechnicians(e.target.value)}
                  input={<OutlinedInput label="Technician" />}
                  size="small"
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((id) => {
                        const tech = technicians.find((t) => t._id === id);
                        return (
                          <Chip
                            key={id}
                            label={tech?.userName}
                            // color="success"
                          />
                        );
                      })}
                    </Box>
                  )}
                >
                  {technicians?.map((tech) => (
                    <MenuItem key={tech._id} value={tech._id}>
                      <Checkbox
                        checked={selectedTechnicians?.includes(tech._id)}
                      />
                      <ListItemText primary={tech.userName} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <Grid item md={2} xs={12}>
            {investigation?.investigation?.resultType ? (
              <Button
                sx={{ width: "100%", height: "100%" }}
                variant="contained"
                color="warning"
                onClick={update}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </Button>
            ) : (
              <Button
                sx={{ width: "100%", height: "100%" }}
                variant="contained"
                color="success"
                onClick={submit}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            )}
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default MicroBioInvestigation;
